import Vue from 'vue'
import $glAuth from '@/services/$glAuth'

/*
  how to use:
    v-gl-admin-only="true"
*/
Vue.directive('gl-admin-only', {
  // on insert
  inserted (el, binding, vnode) {
    // if below admin -> remove element
    if ($glAuth.belowAdmin()) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-admin-only.js